import { render, staticRenderFns } from "./electronicBrochure.vue?vue&type=template&id=455fb798&scoped=true"
import script from "./electronicBrochure.vue?vue&type=script&lang=js"
export * from "./electronicBrochure.vue?vue&type=script&lang=js"
import style0 from "./electronicBrochure.vue?vue&type=style&index=0&id=455fb798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fb798",
  null
  
)

export default component.exports